/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';
import { RESERVATION_HOLDS_ENDPOINTS } from './lais/endpoints';

/**
 * ReservationHoldsAPI — B12 reserva/sinal client over the reservation aggregate.
 *
 * `place` requires an Idempotency-Key (anti double-booking); confirm/release/
 * cancel are member commands whose invariants (settle-before-confirm) live in
 * ReservationHolds::HoldService. Gated by the reservation feature — the backend
 * answers 403 when disabled, which surfaces map to a permission state.
 */
class ReservationHoldsAPI extends ApiClient {
  constructor() {
    super('reservation_holds', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  forListing(imovelListingId, params = {}) {
    return this.get({ imovel_listing_id: imovelListingId, ...params });
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  timeline(id) {
    return axios.get(
      resourcePath(this.url, id, RESERVATION_HOLDS_ENDPOINTS.timeline),
      requestConfig()
    );
  }

  place(payload = {}) {
    const config = requestConfig();
    config.headers['Idempotency-Key'] =
      payload.idempotency_key ||
      payload.idempotencyKey ||
      window.crypto.randomUUID();
    return axios.post(this.url, payload, config);
  }

  confirm(id, payload = {}) {
    return this.command(id, RESERVATION_HOLDS_ENDPOINTS.confirm, payload);
  }

  release(id, payload = {}) {
    return this.command(id, RESERVATION_HOLDS_ENDPOINTS.release, payload);
  }

  cancel(id, payload = {}) {
    return this.command(id, RESERVATION_HOLDS_ENDPOINTS.cancel, payload);
  }

  refundPaymentIntent(id, payload = {}) {
    const config = requestConfig();
    config.headers['Idempotency-Key'] =
      payload.idempotency_key ||
      payload.idempotencyKey ||
      window.crypto.randomUUID();
    return axios.post(
      resourcePath(this.paymentIntentsUrl, id, 'refund'),
      payload,
      config
    );
  }

  get paymentIntentsUrl() {
    return this.url.replace(/reservation_holds$/, 'payment_intents');
  }

  command(id, action, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, action),
      payload,
      requestConfig()
    );
  }
}

export default new ReservationHoldsAPI();
